const isDev = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG === 'true';

const clientLogger = {
  error: (...args) => console.error(...args),
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.log(...args); },
  debug: (...args) => { if (isDev) console.log('[DEBUG]', ...args); },
};

export default clientLogger;
